<template>
  <div class="wrap talk" v-if="!isComplete">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt tit">
            <h1>사진업로드</h1>
          </section>
          <section>
            <div class="con-box info">
              <ol>
                <li>
                  반납하시는 테블릿의 정면, 후면, 측면4컷 사진을 촬영하고 업로드
                  해 주셔야 신청처리가 완료됩니다.
                </li>
                <li>
                  설정된 비빌번호를 모두 해제해 주시고, iCloud, 구글, 삼성서비스
                  계정을 삭제해 주세요.
                </li>
                <li>
                  아래 사진 예시 확인하시고, 촬영 업로드 진행 바랍니다.
                  <dl>
                    <dt>
                      <span>정면:</span> 기기의 설정화면에서 테블릿 정보가
                      학인되도록 촬영
                    </dt>
                    <dt>
                      <span class="blue">삼성기기:</span> 설정 -> 테블릿정보
                      (imei또는 일련번호)
                    </dt>
                    <dt>
                      <span class="blue">애플기기:</span> 설정 -> 일반 -> 정보
                      (imei또는 일련번호)
                    </dt>
                    <dt class="mar_t10">
                      <span>후면:</span> 전체로 촬영(라벨이 있는 경우 확대
                      인식가능)
                    </dt>
                  </dl>
                </li>
              </ol>
            </div>
          </section>
          <section>
            <div class="con-box">
              <h2>사진업로드</h2>
              <div class="photo-info">
                <p>
                  사진 촬영 업로드 예시<br /><span class="gray8"
                    >(모델명, S/N확인 가능하도록 촬영 업로드)</span
                  >
                </p>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_t1.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">정면예시</span>
                </div>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_t2.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">후면예시</span>
                </div>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_t3.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">측면예시1</span>
                </div>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_t4.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">측면예시2</span>
                </div>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_t5.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">측면예시3</span>
                </div>
                <div class="imgbox">
                  <img
                    src="@/assets/images/ex_t6.jpg"
                    style="max-width: 100%; height: auto"
                    alt=""
                  />
                  <span class="title-box">측면예시4</span>
                </div>
                <div class="text-box addfile">
                  <input
                    ref="pcImage"
                    type="file"
                    accept="image/*"
                    @change="uploadImage()"
                    multiple="multiple"
                  />
                  <button type="button" class="btn-file">파일선택</button>
                </div>
                <!-- 첨부파일 이미지 미리보기 이미지  -->
                <div class="imgbox-view">
                  <div class="info-box">
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage0"
                        src="@/assets/images/character.png"
                        alt=""
                      />
                      <span class="btn-close" @click="delImg(0)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage1"
                        src="@/assets/images/character.png"
                        alt=""
                      />
                      <span class="btn-close" @click="delImg(1)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                  </div>
                  <div class="info-box">
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage2"
                        src="@/assets/images/character.png"
                        alt=""
                      />
                      <span class="btn-close" @click="delImg(2)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage3"
                        src="@/assets/images/character.png"
                        alt=""
                      />
                      <span class="btn-close" @click="delImg(3)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                  </div>
                  <div class="info-box">
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage4"
                        src="@/assets/images/character.png"
                        alt=""
                      />
                      <span class="btn-close" @click="delImg(4)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                    <a href="javascript:void(0);">
                      <img
                        name="pcImage"
                        id="pcImage5"
                        src="@/assets/images/character.png"
                        alt=""
                      />
                      <span class="btn-close" @click="delImg(5)"
                        ><i class="xi-close-min"></i
                      ></span>
                    </a>
                  </div>
                </div>
                <!-- //첨부파일 이미지 미리보기 이미지  -->
              </div>
            </div>
          </section>
          <!-- 버튼  -->
          <div class="btn-wrap">
            <a
              href="javascript:void(0);"
              class="talk-btn btn-black"
              @click.stop.prevent="save"
              >등록하기</a
            >
          </div>
          <!-- //버튼  -->
        </article>
      </main>
    </div>
  </div>
  <div class="wrap talk" v-else-if="isComplete">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section class="txt tit">
            <h1>사진업로드 등록 완료</h1>
          </section>

          <section class="ro-top">
            <div class="box1 row row_c row_jsc">
              <span><i class="xi-check"></i></span>
              <p>사진업로드가 완료 되었습니다.</p>
            </div>
          </section>
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'TabletPhtgUpld',
  components: {},
  data: () => ({
    isComplete: false,
    ordNum: '',
    AppConfig: AppConfig,
    srcImg: null, // when mounted , data Setting
    maxSize: 10 * 1024 * 1024, // 10MB
    upLoadFiles: null,
    tmpUpLoadFiles: null
  }),
  computed: {},
  mounted () {
    this.TabletPhtgUpldInit()
  },
  methods: {
    showLoading: function (name) {
      var html =
        '<div id="loading" name="loading" class="' +
        name +
        '"><div class="car"></div></div>'
      $('html').append(html)
      $('.' + name).show()
    },
    hideLoading: function (name) {
      $('.' + name).hide()
      $('.' + name).remove()
    },
    delImg: function (imgNum) {
      console.log(' imgNum =>> ', imgNum)

      var eImg = document.getElementsByName('pcImage')
      eImg[imgNum].src = this.srcImg
    },
    uploadImage: function (e) {
      var imgFiles = this.$refs['pcImage'].files
      
      var chkFileName = ''
      for(var i=0 ; i < imgFiles.length ; i++){
    	  console.log('파일명 : ', imgFiles[i].name)
    	  chkFileName = imgFiles[i].name.slice(imgFiles[i].name.indexOf(".") + 1).toLowerCase()
    	  
    	  if(chkFileName != "jpg" && chkFileName != "jpeg" && chkFileName != "png" &&  chkFileName != "gif" &&  chkFileName != "bmp"){
    		  alert("이미지 파일은 (jpg, jpeg, png, gif, bmp) 형식만 등록 가능합니다.")
    		  return
    	  }
      }

      var eImgs = document.getElementsByName('pcImage')
      var inSrcImg = this.srcImg

      var eImgsIdx = 0
      for (var zzz = 0; zzz < eImgs.length; zzz++) {
        if (inSrcImg == eImgs[zzz].src) {
          eImgsIdx++ // 업로드 안된 이미지 갯수
        }
      }

      console.log(' eImgsIdx length : ', eImgsIdx)
      console.log(' imgFiles length: ', imgFiles.length)

      if (imgFiles.length > eImgsIdx) {
        // 업로드 할려는 이미지 갯수를 제한
        alert('이미지 파일은 6개까지 등록가능 합니다!(전면, 후면,측면1,2,3,4)')
        return
      }

      console.log('First upLoadFiles :', this.uploadFiles)
      if (this.upLoadFiles == null) {
        this.upLoadFiles = imgFiles
        this.tmpUpLoadFiles = Array.from(this.upLoadFiles)
      }

      var tmpUpLoadFiles = this.tmpUpLoadFiles
      var arrFiles = Array.from(imgFiles)

      console.log('tmpUpLoadFiles : ', this.tmpUpLoadFiles)

      var reader = new FileReader()
      function readFile (index) {
        if (index >= imgFiles.length) return
        reader.onload = function (e) {
          var rIdx = 0
          while (true) {
            if (rIdx > 5) break
            if (inSrcImg == eImgs[rIdx].src) {
              eImgs[rIdx].src = reader.result
              tmpUpLoadFiles.splice(rIdx, 1, arrFiles[index])
              break
            }
            rIdx++
          }
          readFile(index + 1)
        }
        // }
        reader.readAsDataURL(imgFiles[index])
      }
      readFile(0)
    },
    async save () {
      var eImgsIdx = 0
      var eImgs = document.getElementsByName('pcImage')
      var inSrcImg = this.srcImg

      for (var zzz = 0; zzz < eImgs.length; zzz++) {
        if (inSrcImg == eImgs[zzz].src) {
          eImgsIdx++ // 업로드 안된 이미지 갯수
        }
      }

      console.log(' eImgsIdx : ', eImgsIdx)

      if (eImgsIdx != 0) {
        alert('이미지 파일을 6개(전면, 후면, 측면1,2,3,4 )을 등록해 주세요!')
        return
      }

      var tmpUpLoadFiles = this.tmpUpLoadFiles

      const dT = new DataTransfer()
      for (const tFile of tmpUpLoadFiles) {
        if (tFile != null) dT.items.add(tFile)
      }
      this.upLoadFiles = dT.files

      var upLoadFiles = this.upLoadFiles
      var maxSize = this.maxSize

      console.log(' upload File : ', this.upLoadFiles)

      for (const uFile of upLoadFiles) {
        if (uFile.size > maxSize || uFile.size > maxSize) {
          alert('첨부파일 사이즈 10MB 이내로 등록 가능합니다.')
          return
        }
      }

      const fd = new FormData()
      for (const uFile of upLoadFiles) {
        fd.append('files', uFile)
      }

      fd.append(
        'ordNum',
        new Blob([this.ordNum], { type: 'application/json' })
      )

      console.log('FormData : ', fd)

      const isTrue = await this.$Alert.confirm(
        '사진업로드를 진행 하시겠습니까?'
      )
      if (!isTrue) return

      this.showLoading('Uploading')

      const { data } = await this.$http.post(
        '/api/purchase/pcs/etc/public/tabletFileRegister',
        fd,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (data.status === '200') {
        this.isComplete = true
      } else {
      }

      this.hideLoading('Uploading')
    },
    async TabletPhtgUpldInit () {
      this.uploadFiles = this.$refs['pcImage'].files
      this.srcImg = document.getElementById('pcImage0').src // Template 정보

      this.ordNum = this.$route.query.ordNum

      console.log(' ===> ordNum :', this.ordNum)

      if (
        this.ordNum == undefined ||
        this.ordNum == null ||
        this.ordNum == ''
      ) {
        alert('주문번호가 없습니다!')
      }

      const params = {
        ordNum: this.ordNum
      }
      console.log('params ==> {}', params)
      const rtn = await Vue.httpClient
        .get('/api/purchase/pcs/mgmt/public/ord-num', { params })
        .then((res) => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            console.log('===> ordNum Result : ', res.data)
            if (res.data.result == undefined) {
              alert('주문정보가 없습니다!')
            }
          } else {
            this.content = '주문번호가 올바르지 않습니다.'
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/TabletPhtgUpld.vue